/**
 * @generated SignedSource<<52a1426458d15cca30769e20e82d0cd5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotoContent_photoNode$data = {
  readonly firmName: string | null;
  readonly photo: {
    readonly height: number | null;
    readonly id: string;
    readonly name: string | null;
    readonly path: string | null;
    readonly photoLike: {
      readonly photoLikeId?: string | null;
      readonly totalPhotoLikes: number | null;
    } | null;
    readonly room: {
      readonly name: string | null;
    } | null;
    readonly serviceId: string | null;
    readonly styles: ReadonlyArray<{
      readonly name: string | null;
    } | null> | null;
    readonly url: string | null;
    readonly width: number | null;
  } | null;
  readonly projectName: string | null;
  readonly projectUrl: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"FirmDetailsWrapper_photoNode" | "PhotoDetailsWrapper_photoNode">;
  readonly " $fragmentType": "PhotoContent_photoNode";
};
export type PhotoContent_photoNode$key = {
  readonly " $data"?: PhotoContent_photoNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotoContent_photoNode">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = [
  (v0/*:: as any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotoContent_photoNode",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PhotoDetailsWrapper_photoNode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FirmDetailsWrapper_photoNode"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firmName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradePhoto",
      "kind": "LinkedField",
      "name": "photo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "height",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "width",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TradePhotoStyle",
          "kind": "LinkedField",
          "name": "styles",
          "plural": true,
          "selections": (v1/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TradePhotoStyle",
          "kind": "LinkedField",
          "name": "room",
          "plural": false,
          "selections": (v1/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PhotoLike",
          "kind": "LinkedField",
          "name": "photoLike",
          "plural": false,
          "selections": [
            {
              "condition": "hasUserId",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "userId",
                      "variableName": "userId"
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "photoLikeId",
                  "storageKey": null
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalPhotoLikes",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradePhotosQueryOutput",
  "abstractKey": null
};
})();

(node as any).hash = "3f1454b6e13d69cfee8779ed1d336c32";

export default node;
